export default function stripBadCharacters(string) {
  return string.replace(/[^\w]/gi, '');
}
